
namespace TabAurous.Purchase {

    @Serenity.Decorators.registerClass()
    export class RateFixingItemsDialog extends Common.GridEditorDialog<RateFixingItemsRow> {
        protected getFormKey() { return RateFixingItemsForm.formKey; }
        //protected getIdProperty() { return RateFixingItemsRow.idProperty; }
        protected getLocalTextPrefix() { return RateFixingItemsRow.localTextPrefix; }
        // protected getNameProperty() { return RateFixingItemsRow.nameProperty; }
        //protected getService() { return RateFixingItemsService.baseUrl; }
        protected getDeletePermission() { return RateFixingItemsRow.deletePermission; }
        protected getInsertPermission() { return RateFixingItemsRow.insertPermission; }
        protected getUpdatePermission() { return RateFixingItemsRow.updatePermission; }

        protected form = new RateFixingItemsForm(this.idPrefix);

        // #region Public Variables
        public masterId: number;
        public PartyId: number;
        public RateListId: number;
        public LaborListId: number;
        public StoneMarkup: number;
        public LaborMarkup: number;
        public newLineNo: number;
        public Totals: number;
        public HasBom: boolean;
        // #endregion 

        constructor() {
            super();
 

            //Set Numeric Fields as Right Align
            q.setTextRightAlign(this.form.Pieces);
            q.setTextRightAlign(this.form.Weight);
            q.setTextRightAlign(this.form.NetAmount);
            q.setTextRightAlign(this.form.NetWeight);
            q.setTextRightAlign(this.form.DiamondAmount);
            q.setTextRightAlign(this.form.DiamondPieces);
            q.setTextRightAlign(this.form.DiamondWeight);
            q.setTextRightAlign(this.form.GrossAmount);
            q.setTextRightAlign(this.form.Discount);
            q.setTextRightAlign(this.form.OtherAmount);
            q.setTextRightAlign(this.form.OtherWeight);
            q.setTextRightAlign(this.form.OtherPieces);
            q.setTextRightAlign(this.form.UnitRate);
           // q.setTextRightAlign(this.form.Purity);
            q.setTextRightAlign(this.form.StonePieces);
            q.setTextRightAlign(this.form.StoneWeight);
            q.setTextRightAlign(this.form.WstPer);
            q.setTextRightAlign(this.form.WstWt);
            q.setTextRightAlign(this.form.UnitLabour);

            // **** On Pieces Change Event **** 
            this.form.Pieces.changeSelect2(e => {
                var pieces = parseInt(this.form.Pieces.value.toString());                
                var netamount = parseFloat(this.form.NetAmount.value.toString());
                this.form.GrossAmount.value = (pieces * netamount);
            });

            // **** On NetAmount Change Event **** 
            this.form.NetAmount.changeSelect2(e => {
                var pieces = parseInt(this.form.Pieces.value.toString());
                var netamount = parseFloat(this.form.NetAmount.value.toString());
                this.form.GrossAmount.value = (pieces * netamount);
            });

            // **** On Product Change Event **** 
            this.form.ProductId.changeSelect2(e => {
                if (this.form.ProductId.value.toString() != null || this.form.ProductId.value.toString() != "0") {
                    //alert("OKay");
                    var prdid = this.form.ProductId.value;

                    let prddetails;
                    OMS.ProductMasterService.Retrieve({
                        EntityId: parseInt(prdid)
                    }, response => {
                        prddetails = response.Entity
                    }, { async: false });
                    var atb = prddetails.AttributeId;
                    var x = prddetails.ProductName;
                    this.form.ProductCode.value = prddetails.ProductCode;
                    this.form.ProductName.value = prddetails.ProductName;
                    this.form.AttributeId.value = atb.toString();
                    this.form.Weight.value = prddetails.Weight;
                    this.form.Pieces.value = prddetails.Pieces;
                    this.form.OtherPieces.value = prddetails.OtherPieces;
                    this.form.OtherWeight.value = prddetails.OtherWeight;
                    this.form.NetWeight.value = prddetails.NetWeight;
                    this.form.StonePieces.value = prddetails.StonePieces;
                    this.form.StoneWeight.value = prddetails.StoneWeight;
                    this.form.DiamondWeight.value = prddetails.DiamondWeight;
                    this.form.DiamondPieces.value = prddetails.DiamondPieces;
                    
                }


            });

            this.form.CategoryId.changeSelect2(e => {
                this.form.SubCategoryId.CategoryId = parseInt(this.form.CategoryId.value);
                this.form.SubCategoryId.updateItems();
            })
            // **** On Wastage % Change Event **** 
            this.form.WstPer.changeSelect2(e => {
                this.form.WstWt.value = this.form.NetWeight.value * ((this.form.WstPer.value) / 100);

            });

            this.form.HasBom.changeSelect2(e => {
                if (this.form.HasBom.value) {
                    q.hideField(this.form.KaratId)
                    q.hideField(this.form.Purity)
                }
                else {
                    q.showAndSetRequiredField(this.form.KaratId)
                    q.showAndSetRequiredField(this.form.Purity)
                    q.showAndSetRequiredField(this.form.MetalId)
                }

            })
            var min = 0, max = 0, std = 0;
            this.form.KaratId.changeSelect2(e => {
                var KaratId = Q.toId(this.form.KaratId.value);
                var purity: OMS.AttributeMasterRow;
                OMS.AttributeMasterService.Retrieve({ EntityId: parseInt(KaratId) }, response => {
                    purity = response.Entity
                }, { async: false });
                min = purity.MinPurity;
                max = purity.MaxPurity;
                std = purity.StdPurity;
                this.form.Purity.value = std;
                this.form.Purity.value = std;
            });
            this.form.Purity.change(e => {
                var current = this.form.Purity.value;
                if (current < min || current > max) {
                    Q.alert("Enter Purity between  " + min.toString() + "  to  " + max.toString());
                    this.form.Purity.value = std;
                }
            });
          
            // **** On Product Code Change Event **** 
            //Validate Product Code for Duplication 
            this.form.ProductCode.changeSelect2(e => {
                try {
                    let id;
                    OMS.ProductMasterService.CustomList({ ProductCode: this.form.ProductCode.value.toUpperCase() },
                        response => {
                            id = response.Entities[0];
                        }, { async: false });

                    if (id.ProductId != null || id.ProductId > 0) {
                        Q.notifyError("Duplicate Product Code " + this.form.ProductCode.value);
                        this.form.ProductCode.value = "";
                        this.form.ProductCode.element.focus();
                        return;

                    }
                }
                catch (undefined) {

                }
            });

        }
        //To avoid calculation of total weight, amount and pieces while closing the dialog
        onDialogClose() {
            closed = true;
        }
        protected afterLoadEntity() {
            super.afterLoadEntity();
            if (this.entityId != undefined) {
                if (!this.form.HasBom.value) {
                    this.HasBom = false;
                   // q.hideEditorCategory(this.form.BOMDetails);
                   // q.hideField(this.form.BOMDetails);
                    this.form.Weight.value = this.entity.Weight == 0 ? 1 : this.entity.Weight;
                }
            }
        }
         
    }
}